import React from 'react';
import { RouteProps } from 'react-router-dom';
import { authPages, dashboardPagesMenu } from '../menu';
import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

const headers: RouteProps[] = [
	{ path: authPages.login.path, element: null },
	{ path: authPages.signUp.path, element: null },
	{ path: authPages.forgotPassword.path, element: null },
	{ path: authPages.resetPassword.path, element: null },
	{ path: authPages.page404.path, element: null },
	{ path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
	{
		path: `*`,
		element: <DashboardHeader />,
	},
];

export default headers;

